import { i18n } from '@lingui/core'

import type { Category } from '@twisto/api-cms'
import { Typography } from '@twisto/components/atoms/typography'

import { ArticlesSearchInput } from 'homepage/components'

import * as styles from './main-category-header.styles'

export const MainCategoryHeader = ({ category }: { category: Category }) => (
  <header css={styles.header}>
    <div css={styles.headerPatternBackground} />
    <div css={styles.headerContent}>
      <Typography
        align="center"
        color="textPrimary"
        component="h1"
        css={styles.headline}
        fontWeight="heavy"
        variant="h1"
      >
        {category.name}
      </Typography>
      <ArticlesSearchInput
        placeholder={/*i18n*/ i18n._('mainCategory.searchInput.placeholder')}
        rootCategoryId={category.rootCategoryId}
      />
    </div>
  </header>
)
